(() => {
  // Loaded before app scripts: text-only orders must not pass through upload hooks.
  const cartFetch = window.fetch.bind(window);
  const CartFormData = window.FormData;
  const pending = new WeakSet();

  const routeTextOnly = async (event) => {
    const button = event.type === 'click'
      ? event.target.closest?.('button[type="submit"], input[type="submit"]') : null;
    const form = event.type === 'submit' ? event.target : button?.form;
    if (!form?.matches('form[data-type="add-to-cart-form"]')) return;
    const info = form.closest('product-info');
    const selected = info?.querySelector('[data-kirova-personalization-choice] input:checked');
    if (selected?.value !== 'Само текст') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const productForm = form.closest('product-form');
    const submit = form.querySelector('[type="submit"]');
    if (!productForm || !submit || pending.has(form) || submit.disabled) return;
    // Do not fall through to the upload app if personalization has not initialized.
    if (!info.kirovaValidatePersonalization || !info.kirovaSyncPersonalization) return;
    info.kirovaSyncPersonalization();
    if (!info.kirovaValidatePersonalization(event)) return;
    // Uploads Pro may associate required controls from a second app section
    // outside product-info with this form. Validate theme fields only here.
    const appField = field => field.type === 'file' || field.closest?.('[data-kirova-app-kind="upload"], .shopify-app-block');
    for (const field of Array.from(form.elements)) {
      if (!appField(field) && field.willValidate && !field.reportValidity()) return;
    }
    if (submit.getAttribute('aria-disabled') === 'true') return;

    const data = new CartFormData(form);
    // Exclude stale app properties, including uploads selected before switching modes.
    Array.from(form.elements).filter(appField).forEach(field => { if (field.name) data.delete(field.name); });
    const text = info.querySelector('[data-kirova-text-input]');
    data.set('properties[Персонализация]', 'Само текст');
    data.set('properties[Текст за печат]', text.value);
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart) {
      data.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
      data.set('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    pending.add(form);
    submit.setAttribute('aria-disabled', 'true');
    submit.classList.add('loading');
    const spinner = productForm.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');
    productForm.handleErrorMessage();
    try {
      const response = await cartFetch(window.routes.cart_add_url, {
        method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string' ? result.description : 'Продуктът не беше добавен. Проверете варианта и количеството и опитайте отново.');
      }
      // Keep the theme cart, quantities and cart-count subscribers synchronized.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form', productVariantId: data.get('id'), cartData: result,
          });
        } catch (error) { console.error(error); }
      }
      if (!cart) { window.location.assign(window.routes.cart_url); return; }
      try {
        cart.classList.remove('is-empty');
        cart.renderContents(result);
      } catch (error) {
        // The item was added; show the cart rather than inviting a duplicate retry.
        window.location.assign(window.routes.cart_url);
      }
    } catch (error) {
      productForm.handleErrorMessage(error.message || 'Възникна проблем при добавянето. Проверете количката преди нов опит.');
    } finally {
      pending.delete(form);
      submit.removeAttribute('aria-disabled');
      submit.classList.remove('loading');
      spinner?.classList.add('hidden');
    }
  };
  window.addEventListener('click', routeTextOnly, true);
  window.addEventListener('submit', routeTextOnly, true);
})();
